;(() => {
  const runAbra = () => window.Abra?.render?.()
  const scheduleRenders = (delays) => {
    runAbra()
    delays.forEach((delay) => setTimeout(runAbra, delay))
  }

  const checkElement = (element, className) =>
    element.classList?.contains(className) ||
    element.querySelector?.(`.${className}`)

  document.addEventListener('slide-panel-open', () =>
    scheduleRenders([300, 800, 1500, 2500])
  )

  new MutationObserver((mutations) => {
    mutations.forEach(({ type, target, addedNodes }) => {
      if (type === 'childList' && addedNodes.length > 0) {
        if (checkElement(target, 'slide-panel__body-container')) {
          scheduleRenders([200, 500, 1000])
        }

        ;[...addedNodes].forEach((node) => {
          if (
            node.nodeType === 1 &&
            checkElement(node, 'product-details__inner')
          ) {
            scheduleRenders([300, 800, 1500, 2500])
          }
        })
      }
    })
  }).observe(document.body, { childList: true, subtree: true })

  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-toggle-quick-shop, [data-target="quick-shop"]')) {
      ;[1000, 2500, 4000].forEach((delay) => setTimeout(runAbra, delay))
    }
  })
})()

;(() => {
  const isCartPage = () => /\/cart\/?$/.test(location.pathname.toLowerCase())
  if (!isCartPage()) return

  const fireEvents = (delay) => {
    setTimeout(() => {
      document.dispatchEvent(new Event('main-cart::refresh'))
      document.dispatchEvent(new Event('cart::add'))
    }, delay)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fireEvents(1000), {
      once: true,
    })
  } else {
    fireEvents(800)
  }

  document.addEventListener('click', (e) => {
    if (
      e.target.closest('.js-plus') ||
      e.target.closest('.js-minus') ||
      e.target.closest('.main-cart__line-item__remove')
    ) {
      fireEvents(500)
      fireEvents(800)
    }
  })
})()

// Wrap OG prices in a span with price-wrapper attribute
;(() => {
  function wrapOgPrices() {
    document
      .querySelectorAll('.og-optout-wrap og-price[regular]:not([data-wrapped])')
      .forEach((el) => {
        if (!el.parentNode) return
        el.setAttribute('data-wrapped', '')
        const wrapper = document.createElement('span')
        wrapper.setAttribute('price-wrapper', '')
        el.parentNode.insertBefore(wrapper, el)
        wrapper.appendChild(el)
      })
  }

  const tick = (tries = 60) => {
    wrapOgPrices()
    if (tries > 0) setTimeout(() => tick(tries - 1), 100)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => tick())
  } else {
    tick()
  }
})()
